import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/styles.css'; 
import FontAwesomeIcon from './plugins/font-awesome'; // Adjust the path if necessary

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app');
